import React from "react";
import moment from "moment";
import waste from "../../../assets/Images/image/Waste.png";
import close from "../../../assets/Images/icons/Cancel.svg";
import save from "../../../assets/Images/icons/Save.svg";
import edit from "../../../assets/Images/image/edit.png";
import { ThreeDots } from "react-loader-spinner";
import NoRecord from "../../../assets/SharedComponents/Table/NoRecord";

const PartnersTable = ({
  data,
  loaded,
  editable,
  partnerName,
  onPartnerNameChange,
  companyAccess,
  togglingId,
  onEditRecord,
  onEditableChange,
  onPartnerNameSet,
  onStatusToggle,
  onRemove,
}) => {
  if (loaded) {
    return (
      <div className="d-flex justify-content-center three-dot">
        <ThreeDots
          height="150"
          width="150"
          radius="9"
          color="#637df4"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName=""
          visible={true}
        />
      </div>
    );
  }

  return (
    <tbody>
      {data.length > 0 ? (
        data.map((item, index) => {
          const formatDate = (dateStr) =>
            dateStr != null
              ? moment(new Date(dateStr)).tz("Europe/Amsterdam").format("DD-MM-YYYY HH:mm")
              : "-";
          const displayName = item.name
            ? typeof item.name === "string"
              ? item.name.replace("_", " ").charAt(0).toUpperCase() + item.name.replace("_", " ").slice(1)
              : item.name
            : "-";
          const isActive = item.status === 1 || item.is_active === 1;
          const canUpdate = companyAccess?.permissions?.find((o) => o.slug === "update");
          const canDelete = companyAccess?.permissions?.find((o) => o.slug === "delete");
          const showActionColumn = canUpdate || canDelete;

          return (
            <tr className="table-row" key={item.id || index}>
              <td className="tableHead-1">{item.id}</td>
              <td className="tableHead-3">
                {editable === item.id ? (
                  <input
                    type="text"
                    value={partnerName}
                    className="form-control"
                    onChange={(e) => onPartnerNameChange(e.target.value)}
                  />
                ) : (
                  displayName
                )}
              </td>
              <td>
                {canUpdate ? (
                  <label className="form-check form-switch centered-switch">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={isActive}
                      disabled={togglingId === item.id}
                      title={isActive ? "Disable" : "Enable"}
                      onChange={() => onStatusToggle(item.id, !isActive)}
                    />
                  </label>
                ) : isActive ? (
                  <span className="status status-active" title="Active" />
                ) : (
                  <span className="status status-end" title="Inactive" />
                )}
              </td>
              <td>{formatDate(item.created_at)}</td>
              <td>{formatDate(item.updated_at)}</td>
              {showActionColumn ? (
                <td className="tableHead-9">
                  {editable === item.id ? (
                    <>
                      {canUpdate && (
                        <img src={save} alt="" className="mx-2" role="button" onClick={onEditRecord} />
                      )}
                      {canUpdate && (
                        <img src={close} alt="" className="mx-2" role="button" onClick={() => onEditableChange("")} />
                      )}
                    </>
                  ) : (
                    <>
                      {canUpdate && (
                        <img
                          src={edit}
                          alt=""
                          className="mx-2"
                          role="button"
                          onClick={() => {
                            onEditableChange(item.id);
                            onPartnerNameSet(item.name || "");
                          }}
                        />
                      )}
                      {canDelete && (
                        <img
                          src={waste}
                          alt=""
                          className="mx-2"
                          role="button"
                          onClick={() => onRemove(item.id)}
                        />
                      )}
                    </>
                  )}
                </td>
              ) : (
                ""
              )}
            </tr>
          );
        })
      ) : (
        <NoRecord />
      )}
    </tbody>
  );
};

export default PartnersTable;
